import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { useMemo } from "react";

const showTimelineShiftIndicatorsAtom = atomWithStorage(
  "atom:showTimelineShiftIndicatorsAtom",
  true
);
const showTimelineTooltipOnHoverAtom = atomWithStorage(
  "atom:showTimelineTooltipOnHover",
  true
);
const showSkuDescriptionInsteadOfIdAtom = atomWithStorage(
  "atom:showSkuDescriptionInsteadOfId",
  false
);

export const INITIAL_VISIBLE_TIMELINES = {
  teamSize: true,
  operator: true,
  sku: true,
  count: true,
  rejectCount: true,
  grossRejectNetTicks: true,
  speedGainLoss: false,
};
/** can be any key of INITIAL_VISIBLE_TIMELINES */
export type VisibleSubTimelines = keyof typeof INITIAL_VISIBLE_TIMELINES;
/** which subtimelines are visible below SingleTimeline -- keys are used in TIMELINE_SUBSEGMENTS_ORDER */
const visibleSubTimelinesAtom = atomWithStorage(
  "atom:visibleSubTimelines",
  INITIAL_VISIBLE_TIMELINES
);

export const useTimelinesStore = () => {
  const [showTimelineShiftIndicators, setShowTimelineShiftIndicators] = useAtom(
    showTimelineShiftIndicatorsAtom
  );
  const [showTimelineTooltipOnHover, setShowTimelineTooltipOnHover] = useAtom(
    showTimelineTooltipOnHoverAtom
  );
  const [showSkuDescriptionInsteadOfId, setShowSkuDescriptionInsteadOfId] =
    useAtom(showSkuDescriptionInsteadOfIdAtom);
  const [visibleSubTimelines, setVisibleSubTimelines] = useAtom(
    visibleSubTimelinesAtom
  );
  return {
    showTimelineShiftIndicators,
    setShowTimelineShiftIndicators,
    showTimelineTooltipOnHover,
    setShowTimelineTooltipOnHover,
    showSkuDescriptionInsteadOfId,
    setShowSkuDescriptionInsteadOfId,
    visibleSubTimelines,
    setVisibleSubTimelines,
  };
};

export function useNumVisibleSubTimelines() {
  const { visibleSubTimelines } = useTimelinesStore();
  return useMemo(() => {
    const numSkuOperatorTimelineRows =
      Object.values(visibleSubTimelines).filter(Boolean).length +
      // if the list includes grossRejectNetTicks, add an extra 2 rows
      (visibleSubTimelines.grossRejectNetTicks ? 2 : 0);
    return numSkuOperatorTimelineRows;
  }, [visibleSubTimelines]);
}
